import type {
  CargaTrabalhoObrasData,
  CargaTrabalhoProfissionaisData,
} from "@/modules/carga-trabalho";
import type { AlocacoesPorLocal, AlocacoesPorObra } from "@/modules/carga-de-trabalho";
import type { CargaFornecedorDados } from "../carga-fornecedor.filters";

/** Alocação real da carga, no formato que o Comparar consulta. */
export interface AlocacaoViva {
  id: string;
  obraId: string;
  recursoId: string;
  recursoNome: string;
  inicio: string;
  fim: string;
}

/** Recorte da carga já carregada na perspectiva visível. */
export interface CargaAtualComparacao {
  tipo: "profissional" | "fornecedor" | "local";
  alocacoes: readonly AlocacaoViva[];
}

export function cargaDeProfissionais(data: CargaTrabalhoProfissionaisData): CargaAtualComparacao {
  return {
    tipo: "profissional",
    alocacoes: data.profissionais.flatMap((profissional) =>
      profissional.alocacoes.map((alocacao) => ({
        id: alocacao.id,
        obraId: alocacao.obra.id,
        recursoId: profissional.id,
        recursoNome: profissional.nome,
        inicio: alocacao.inicio,
        fim: alocacao.fim,
      })),
    ),
  };
}

export function cargaDeObras(data: CargaTrabalhoObrasData): CargaAtualComparacao {
  return {
    tipo: "profissional",
    alocacoes: data.obras.flatMap((obra) =>
      obra.profissionais.map((membro, index) => ({
        id: membro.alocacaoId ?? `${obra.id}:${membro.id}:${index}`,
        obraId: obra.id,
        recursoId: membro.id,
        recursoNome: membro.nome,
        inicio: membro.inicio,
        fim: membro.fim,
      })),
    ),
  };
}

export function cargaDeFornecedores(dados: CargaFornecedorDados): CargaAtualComparacao {
  if (dados.agrupamento === "obra") {
    return {
      tipo: "fornecedor",
      alocacoes: dados.obras.flatMap((obra) =>
        obra.alocacoes.map((alocacao) => ({
          id: alocacao.id,
          obraId: obra.id,
          recursoId: alocacao.fornecedor.id,
          recursoNome: alocacao.fornecedor.nome,
          inicio: alocacao.inicio,
          fim: alocacao.fim,
        })),
      ),
    };
  }

  return {
    tipo: "fornecedor",
    alocacoes: dados.fornecedores.flatMap((fornecedor) =>
      fornecedor.alocacoes.map((alocacao) => ({
        id: alocacao.id,
        obraId: alocacao.obra.id,
        recursoId: fornecedor.id,
        recursoNome: fornecedor.nome,
        inicio: alocacao.inicio,
        fim: alocacao.fim,
      })),
    ),
  };
}

export function cargaDeLocais(data: AlocacoesPorLocal): CargaAtualComparacao {
  return {
    tipo: "local",
    alocacoes: data.locais.flatMap((local) =>
      local.alocacoes.map((alocacao) => ({
        id: alocacao.id,
        obraId: alocacao.obra.id,
        recursoId: local.id,
        recursoNome: local.nome,
        inicio: alocacao.inicio,
        fim: alocacao.fim,
      })),
    ),
  };
}

export function cargaDeObrasLocal(data: AlocacoesPorObra): CargaAtualComparacao {
  return {
    tipo: "local",
    alocacoes: data.obras.flatMap((obra) =>
      obra.alocacoes.map((alocacao) => ({
        id: alocacao.id,
        obraId: obra.id,
        recursoId: alocacao.local.id,
        recursoNome: alocacao.local.nome,
        inicio: alocacao.inicio,
        fim: alocacao.fim,
      })),
    ),
  };
}
